import React from 'react';
import { Input } from '@/components/ui/input';
import { Podcast } from '@/types/civic-education';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

interface PodcastFieldsProps {
  item: Podcast;
  onFieldChange: (field: keyof Podcast, value: any) => void;
}

const PodcastFields = ({ item, onFieldChange }: PodcastFieldsProps) => {
  const handlePodcastSourceChange = (value: string) => {
    onFieldChange('source', value);
  };

  // Extract Spotify Episode ID from URL if pasted
  const handleEpisodeIdChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    
    // Check if it's a full Spotify URL and extract the ID
    if (value.includes('spotify.com/episode/')) {
      try {
        const regex = /episode\/([a-zA-Z0-9]+)/;
        const match = value.match(regex);
        
        if (match && match[1]) {
          onFieldChange('episode_id', match[1]);
          return;
        }
      } catch (error) {
        console.error("Error parsing Spotify URL:", error);
      }
    }
    
    // Otherwise just store the value as is
    onFieldChange('episode_id', value);
  };

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <label htmlFor="source" className="text-sm font-medium">Podcast Source</label>
        <Select 
          value={item.source || 'spotify'} 
          onValueChange={handlePodcastSourceChange}
        >
          <SelectTrigger>
            <SelectValue placeholder="Select source" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="spotify">Spotify</SelectItem>
            <SelectItem value="apple">Apple Podcasts</SelectItem>
            <SelectItem value="google">Google Podcasts</SelectItem>
            <SelectItem value="other">Other</SelectItem>
          </SelectContent>
        </Select>
      </div>
      
      <div className="space-y-2">
        <label htmlFor="episode_id" className="text-sm font-medium">Episode ID</label>
        <Input
          id="episode_id"
          value={item.episode_id}
          onChange={handleEpisodeIdChange}
          required
        />
        <p className="text-xs text-muted-foreground">
          {item.source === 'spotify' || !item.source ? 
            "Enter the Spotify episode ID (e.g., '4ycOsqof9H7f4FtgSBrwT5') or paste the full Spotify episode URL" : 
            "Enter the episode ID for the selected platform"}
        </p>
      </div>
      
      <div className="space-y-2">
        <label htmlFor="duration" className="text-sm font-medium">Duration (minutes)</label>
        <Input
          id="duration"
          type="number"
          value={item.duration || ''}
          onChange={(e) => onFieldChange('duration', parseInt(e.target.value))}
        />
      </div>
      
      <div className="space-y-2">
        <label htmlFor="host" className="text-sm font-medium">Host</label>
        <Input
          id="host"
          value={item.host || ''}
          onChange={(e) => onFieldChange('host', e.target.value)}
        />
      </div>
    </div>
  );
};

export default PodcastFields;
